module.exports = __webpack_public_path__ + "static/img/12_northern_japan.344873c7.png";